import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PublicLayout, { H1, Lead } from "../../components/PublicLayout";
import { SITE } from "../../content/site";
import { routePath, SITE_URL } from "../../lib/routes";
import { orgRef } from "../../components/Seo";
import { track, EVENTS } from "../../lib/analytics";

const VISUALS = {
  productArena: "/assets/products/arena.webp",
  productCentauros: "/assets/products/centauros.webp",
  productAos: "/assets/products/aos.webp",
};

export default function Products({ lang }) {
  const c = SITE[lang].products;
  const common = SITE[lang].common;
  useEffect(() => { window.scrollTo(0, 0); }, [lang]);
  const ld = [{
    "@context": "https://schema.org", "@type": "ItemList",
    itemListElement: c.items.map((p, i) => ({
      "@type": "ListItem", position: i + 1,
      item: { "@type": "Service", name: p.name, serviceType: "Equestrian software platform", url: `${SITE_URL}${routePath(p.key, lang)}`, provider: orgRef(), brand: orgRef(), description: p.desc },
    })),
  }];
  return (
    <PublicLayout pageKey="products" lang={lang} jsonLd={ld}
      crumbs={[{ name: SITE[lang].breadcrumbs.products, path: routePath("products", lang) }]}>
      <div className="mx-auto max-w-[1100px] px-6 py-14 md:px-8 md:py-20" data-testid="products-page">
        <H1>{c.h1}</H1>
        <Lead>{c.intro}</Lead>
        <p className="mt-4 max-w-2xl text-sm font-light italic text-[#9a9d98]">{c.note}</p>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {c.items.map((p) => (
            <Link key={p.key} to={routePath(p.key, lang)} data-testid={`product-card-${p.name.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => track(EVENTS.PRODUCT_VIEWED, { product: p.name, from: "products_index" })}
              className="group flex flex-col overflow-hidden rounded-3xl border border-black/8 transition-shadow hover:shadow-[0_8px_40px_rgba(0,0,0,0.08)]">
              <div className="bg-white">
                <img src={VISUALS[p.key]} alt={`${p.name} — ${p.tagline}`} loading="lazy" width="1200" height="1200"
                  className="h-52 w-full object-contain px-4 pt-6 transition-transform duration-700 group-hover:scale-[1.03] sm:h-60" />
              </div>
              <div className="flex flex-1 flex-col p-7 pt-4">
              <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#0e7c6b]">{common.inDevelopment}</span>
              <h2 className="mt-3 font-display text-2xl font-normal text-[#050505]">{p.name}</h2>
              <p className="mt-1 text-sm font-medium text-[#4a4a4a]">{p.tagline}</p>
              <p className="mt-3 flex-1 text-sm font-light leading-relaxed text-[#6b6f6c]">{p.desc}</p>
              <span className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-[#0e7c6b]">{common.learnMore} <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" /></span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
